var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
import { colors } from '../../theme';
var BannerImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n\n  &.inside-drawer {\n    margin-bottom: ", "px;\n\n    @media ", " {\n      margin: 0;\n      padding: ", "px 0;\n      background-color: ", ";\n    }\n  }\n"], ["\n  height: ", ";\n  width: ", ";\n\n  &.inside-drawer {\n    margin-bottom: ", "px;\n\n    @media ", " {\n      margin: 0;\n      padding: ", "px 0;\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var width = _a.width;
    return width;
}, spacing.base, query.lessThanMedium, spacing.small, colors.white);
export default BannerImage;
var templateObject_1;
